<prism-tooltip [text]="statusTooltip()" placement="top">
	<prism-status-indicator
		*transloco="let t; read: 'scDeviceStateBar'"
		id="sh-device-state-bar"
		shape="rectangle"
		[status]="prismState()"
	></prism-status-indicator>
</prism-tooltip>
